export default {"src":"/_next/static/media/location.561f195f.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};